












import Vue from "vue";
export default Vue.extend({
  props: {
    CASScaleData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      innerCASScaleData: { ...this.CASScaleData }
    };
  },
  methods: {
    handleSwitchChange(e, prop) {
      this.$set(this.innerCASScaleData, prop, e.checked ? 2 : 1);
    },
    getData() {
      return {
        ScaleSwitchEnabled: this.innerCASScaleData.ScaleSwitchEnabled,
        ScalePortOne: this.innerCASScaleData.ScalePortOne
      };
    }
  }
});
